<template>
    <div data-testid="client-medical-reports-page">
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                    Filtrování
                </div>
                <div class="col-md-8 text-center">

                </div>
                <div class="col-md-2 text-right">
                    <button @click="loadMedicalReportOfClient()" class="btn btn-secondary btn-sm" data-testid="client-medical-reports-refresh"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="medicalReports.length > 0">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1">

                    </th>
                    <th class="col-sm-3">Datum návštěvy</th>
                    <th class="col-sm-3">Doktor</th>
                    <th class="col-sm-5"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(mr, index) in medicalReports" class="card-text">
                    <tr class="row m-0" :class="openedMedicalReportId === mr.id ? 'border border-primary border-bottom-0' : ''" :data-testid="'client-medical-report-row-' + mr.id">
                        <td class="align-middle col-sm-1">
                            <button class="btn btn-sm btn-primary" @click="openMedicalReportId(mr.id, mr)" v-if="openedMedicalReportId === mr.id" :data-testid="'client-medical-report-toggle-' + mr.id"><i class="fa fa-minus-square-o" aria-hidden="true"></i></button>
                            <button class="btn btn-sm btn-secondary" @click="openMedicalReportId(mr.id, mr)" v-else="" :data-testid="'client-medical-report-toggle-' + mr.id"><i class="fa fa-plus-square-o" aria-hidden="true"></i></button>
                            <!-- <visit-change-state v-on:update="loadMedicalReportOfClient" :actual-state="task.state" :selected-doctor-id="task.planned_for.id" :visit-id="task.id"></visit-change-state> -->
                        </td>
                        <td class="col-sm-3">{{ mr.visit.date }}</td>
                        <td class="col-sm-3">{{ mr.visit.planned_for.fullname }}</td>
                        <td class="col-sm-5"></td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0" v-if="openedMedicalReportId === mr.id" :data-testid="'client-medical-report-detail-' + mr.id">
                        <template v-if="editedMedicalReportId === mr.id">
                            <td class="col-md-6 border">
                                <b class="p-4">Původní lékařská zpráva</b><br>
                                <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="medical_report_text" v-html="mr.text">

                                </div>
                            </td>
                            <td class="col-md-6 border">
                                <b class="p-4">Úprava lékařské zprávy</b> <button class="btn btn-sm btn-warning" @click="editMedicalReportId(mr.id, mr)"><i class="fa fa-times" aria-hidden="true"></i> zrušit úpravu</button>
                                <div class="p-4">
                                    <vue-editor v-model="editedMedicalReportText" :editorToolbar="customToolbar" :data-testid="'client-medical-report-editor-' + mr.id"></vue-editor>
                                </div>
                                <div class="p-4">
                                    <label for="printDate">Datum tisku:</label>
                                    <datepicker v-model="editedMedicalReportPrintDate" placeholder="vybrat datum tisku" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="printDate" id="printDate" :data-testid="'client-medical-report-print-date-' + mr.id"></datepicker>

                                </div>
                                <div class="row m-0 p-4">
                                    <medical-report-confirm-save @confirmed="saveEditedMedicalReport(mr.visit.id)" v-if="medicalReportPending === false"></medical-report-confirm-save>
                                    <button class="btn btn-outline-success disabled mr-2" disabled="disabled" v-else=""><i class="fa fa-spinner fa-pulse fa-fw"></i> Uložit</button>
                                    <!-- <a class="btn btn-sm btn-success" target="_blank" role="button" :href="hostname.hostname + 'visit/' + mr.visit.id + '/medical_report/pdf?text=' + editedMedicalReportText"><i class="fa fa-print"></i> Tisknout zprávu</a> -->
                                    <button class="btn btn-sm btn-primary mr-2" @click="downloadPdf(mr)" v-if="printMedicalReportPending === false"><i class="fa fa-print" aria-hidden="true"></i> Tisknout</button>
                                    <button class="btn btn-sm btn-primary disabled mr-2" disabled="disabled" v-else=""><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i> Tisknout</button>
                                    <button class="btn btn-sm btn-primary" @click="sendMedicalReport(mr)" v-if="sendMedicalReportPending === false"><i class="fa fa-mail-forward" aria-hidden="true"></i> Odeslat e-mailem</button>
                                    <button class="btn btn-sm btn-primary disabled" disabled="disabled" v-else=""><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i> Odeslat e-mailem</button>
                                </div>
                            </td>
                        </template>
                        <td class="col-md-12" v-else="">
                            <b class="p-4">Lékařská zpráva</b>
                            <button class="btn btn-sm btn-warning mr-2" :data-testid="'client-medical-report-edit-' + mr.id" @click="editMedicalReportId(mr.id, mr)"><i class="fa fa-pencil" aria-hidden="true"></i> upravit</button>
                            <a class="btn btn-sm btn-primary" target="_blank" role="button" :data-testid="'client-medical-report-print-' + mr.id" :href="hostname.hostname + 'visit/' + mr.visit.id + '/medical_report/pdf'"><i class="fa fa-print"></i> Tisknout</a>
                            <button class="btn btn-sm btn-primary" :data-testid="'client-medical-report-email-' + mr.id" @click="sendMedicalReport(mr)" v-if="sendMedicalReportPending === false"><i class="fa fa-mail-forward" aria-hidden="true"></i> Odeslat e-mailem</button>
                            <button class="btn btn-sm btn-primary disabled" disabled="disabled" v-else=""><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i> Odeslat e-mailem</button>

                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="medical_report_text" v-html="mr.text">

                            </div>
                        </td>
                    </tr>

                </template>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="medicalReportsPending">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (nebyl nalezen žádný výsledek dle požadavků)
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import Datepicker from 'vuejs-datepicker'
  import { VueEditor } from 'vue2-editor'

  import MedicalReportConfirmSave from '@/views/Client/popovers/MedicalReportConfirmSave.vue'

  export default {
    data () {
      return {
        visits_header_title: '',
        hostname: require('@/variables.js'),
        get_params: {
          date: ''
        },
        selectedStates: [],
        print_date: '',
        assignedTo: '', // localStorage.getItem('userid'),
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        selectedDate: '',
        medicalReports: false,
        medicalReportsError: false,
        medicalReportsPending: true,
        editingTaskId: false,
        editingTask: {},
        waitForSave: false,
        openedMedicalReportId: false,
        openedTaskEvaluation: '',
        editedMedicalReportId: false,
        updatedTask: {
          evaluation: '',
          state: '',
          client_id: false,
          include_result_to_email: true
        },
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        state: '',
        customToolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'color': []}],
          [{'align': []}]
        ],
        editedMedicalReportText: '',
        editedMedicalReportPrintDate: false,
        // Post edited Medical Report
        medicalReportPending: false,
        medicalReportError: false,
        medicalReportDone: false,
        printMedicalReportPending: false,
        sendMedicalReportPending: false
      }
    },
    mixins: [apiMixin],
    methods: {
      downloadPdf (medicalReport) {
        this.printMedicalReportPending = true
        let params = {
          updated_text: this.editedMedicalReportText,
          print_date: this.editedMedicalReportPrintDate !== false ? this.$moment(this.editedMedicalReportPrintDate).format('DD.MM.YYYY') : false
        }
        this.$http.post('visit/' + medicalReport.visit.id + '/medical_report/pdf', params, {responseType: 'arraybuffer'}).then((response) => {
          let blob = new Blob([response.data], { type: 'application/pdf' })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'medical_report_' + this.$moment().format('YYYYMMDD') + '_' + medicalReport.visit.id + '.pdf'
          link.click()

          this.printMedicalReportPending = false
          /* let url = window.URL.createObjectURL(blob)
          let newWin = window.open(url)

          if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'medical_report_' + this.$moment().format('YYYYMMDD') + '_' + medicalReport.visit.id + '.pdf'
            link.click()
          } */
        }).catch(error => {
          console.log(error)
          this.printMedicalReportPending = false
        })
      },
      sendMedicalReport (medicalReport) {
        this.sendMedicalReportPending = true
        let params = {
          updated_text: this.editedMedicalReportText,
          print_date: this.editedMedicalReportPrintDate !== false ? this.$moment(this.editedMedicalReportPrintDate).format('DD.MM.YYYY') : false
        }
        this.$http.post('visit/' + medicalReport.visit.id + '/medical_report/email', params, {responseType: 'arraybuffer'}).then((response) => {
          this.sendMedicalReportPending = false
        }).catch(error => {
          console.log(error)
          this.sendMedicalReportPending = false
        })
      },
      saveEditedMedicalReport (visitId) {
        console.log('ukladam!! :)')
        this.postMedicalReport(visitId, this.editedMedicalReportText)
      },
      openMedicalReportId (num, result) {
        if (this.openedMedicalReportId === num) {
          this.openedMedicalReportId = false
          this.openedMedicalReportEvaluation = ''
        } else {
          this.openedMedicalReportId = num
          // this.openedTaskEvaluation = result.evaluation
          this.updatedTask = {
            evaluation: result.evaluation,
            state: result.state,
            client_id: result.client_id,
            include_result_to_email: true
          }
        }
      },
      editMedicalReportId (num, medicalReport) {
        if (this.editedMedicalReportId === num) {
          this.editedMedicalReportId = false
          this.editedMedicalReportPrintDate = false
          this.editedMedicalReportText = ''
        } else {
          this.editedMedicalReportId = num
          this.editedMedicalReportText = medicalReport.text
          this.editedMedicalReportPrintDate = new Date()
        }
      },
      loadMedicalReportOfClient () {
        this.getMedicalReportOfClient(this.$route.params.clientid)
      },
      showModalChangeTaskDoctor (selectedDoctorId) {
        this.selectedDoctorId = selectedDoctorId
        this.showModal('visit-change-doctor')
      },
      showModal (name) {
        console.log('zobrazuji modal')
        this.$modal.show(name)
      },
      selectClient (value) {
        // console.log('oteviram klienta' + value.id)
        this.updatedTask.client_id = value.id
        this.updatedTask.state = 'assigned'
      },
      getResult (text) {
        // loading(true)
        if (text.length > 2) {
          this.searchClients(text)
        }
      }
    },
    beforeMount () {
      this.getDoctors()
      this.selectedStates = ['completed']
      this.loadMedicalReportOfClient()
    },
    watch: {
      medicalReportDone (val) {
        if (val === true) {
          this.loadMedicalReportOfClient()
          this.medicalReportDone = false
        }
      },
      selectedStates: function (val) {
        // localStorage.setItem('home_states', JSON.stringify(val))
        // if (!this.waiting) {
        this.loadMedicalReportOfClient()
        // }
      },
      assignedTo: function () {
        // if (!this.waiting) {
        this.loadMedicalReportOfClient()
        // }
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.loadMedicalReportOfClient()
        }
      }
    },
    components: {
      // TaskChangeDoctor,
      // TaskChangeState,
      Datepicker,
      VueEditor,
      MedicalReportConfirmSave
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientMedicalReport.vue?425ecbd6